module.exports = __webpack_public_path__ + "static/media/24_B.feae42ce.png";